import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import runtimeEnv from "@mars/heroku-js-runtime-env";
import axios from "axios";
import { formatLocationIdForBackend } from "../helpers";
import Grid from "@material-ui/core/Grid";
import ResponsiveMobileStepper from "./ResponsiveMobileStepper";
import NextBackButtons from "./NextBackButtons";
import { Typography } from "@material-ui/core";
import { Formik } from "formik";
import * as yup from "yup";
import LocationSelect from "./LocationSelect";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import FormErrorMessage from "./FormErrorMessage";
import Button from "@material-ui/core/Button";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const styles = (theme) => ({
  root: {
    textAlign: "center",
  },
  introText: {
    fontSize: 32,
    maxWidth: 775,
    paddingBottom: theme.spacing(8),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  locationTextField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  rangeDialog: {
    textAlign: "center",
  },
  icon: {
    fontSize: "3.75rem",
  },
  dialogActions: {
    justifyContent: "center",
  },
});

class OriginDestination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rangeModalOpen: false,
      rangeModalSubmitted: false,
    };
  }

  handleRangeModalOpen = () => {
    this.setState({ rangeModalOpen: true });
  };

  handleRangeModalClose = () => {
    this.setState({ rangeModalOpen: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <Formik
          validateOnChange={true}
          validationSchema={yup.object({
            originLocationId: yup.object().shape({
              label: yup.string().label("Your starting address").required(),
              value: yup.string().required(),
            }),
            destinationLocationId: yup.object().shape({
              label: yup.string().label("Your moving address").required(),
              value: yup.string().required(),
            }),
          })}
          initialValues={
            (!(
              Object.entries(this.props.values).length === 0 &&
              this.props.values.constructor === Object
            ) &&
              this.props.values) || {
              //If there are already values, use those - make sure it's not just an empty object though, see https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
              originLocationId: {
                label: "",
                value: "",
              },
              destinationLocationId: {
                label: "",
                value: "",
              },
            }
          }
          onSubmit={(values, actions) => {
            window.dataLayer.push({
              event: "moving-address-continue",
              eventProps: {
                category: "Ecommerce",
                action: "Click",
                label: "Page 3 - Moving Address Continue",
              },
            });

            // duplicate the object
            let valuesToSendToBackend = JSON.parse(JSON.stringify(values));

            // fix the location ids
            valuesToSendToBackend = formatLocationIdForBackend(
              valuesToSendToBackend
            );

            // then send
            return axios
              .request({
                method: "get",
                url: runtimeEnv().REACT_APP_API_URL + "/inRange",
                params: valuesToSendToBackend,
              })
              .then((response) => {
                const { originLocationId, destinationLocationId } =
                  response.data;
                actions.setSubmitting(false);

                if (originLocationId && destinationLocationId) {
                  this.props.handleNext(values);
                } else {
                  this.values = valuesToSendToBackend;
                  this.handleRangeModalOpen();
                }
              })
              .catch((error) => {
                actions.setSubmitting(false);
                actions.setErrors(error.response.data.fields || {});
                actions.setStatus({ message: error.response.data.message });

                console.log(error); //eslint-disable-line no-console
                console.log(error.response); //eslint-disable-line no-console
              });
          }}
          render={({
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            handleChange,
            isSubmitting,
          }) => (
            <form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid className={classes.root}>
                <Typography className={classes.introText}>
                  Enter your moving from and moving to address
                </Typography>
                <LocationSelect
                  id={"originLocationId"}
                  className={classes.locationTextField}
                  onChange={handleChange}
                  value={values["originLocationId"]}
                  isDisabled={isSubmitting}
                  onBlur={handleBlur}
                  // Props to pass to the text field element inside the select box
                  textFieldProps={{
                    required: true,
                    label: "Your starting address",
                    disabled: isSubmitting,
                    helperText:
                      touched["originLocationId"] &&
                      errors["originLocationId"] &&
                      errors["originLocationId"].label,
                    error:
                      touched["originLocationId"] &&
                      !!errors["originLocationId"],
                    margin: "normal",
                    fullWidth: true,
                  }}
                />
                <LocationSelect
                  id={"destinationLocationId"}
                  className={classes.locationTextField}
                  onChange={handleChange}
                  value={values["destinationLocationId"]}
                  isDisabled={isSubmitting}
                  onBlur={handleBlur}
                  // Props to pass to the text field element inside the select box
                  textFieldProps={{
                    required: true,
                    label: "Your moving address",
                    disabled: isSubmitting,
                    helperText:
                      touched["destinationLocationId"] &&
                      errors["destinationLocationId"] &&
                      errors["destinationLocationId"].label,
                    error:
                      touched["destinationLocationId"] &&
                      !!errors["destinationLocationId"],
                    margin: "normal",
                    fullWidth: true,
                  }}
                />
              </Grid>
              <NextBackButtons
                backOnClick={this.props.handleBack}
                disableBoth={isSubmitting}
              />
              <ResponsiveMobileStepper
                steps={this.props.steps}
                activeStep={this.props.activeStep}
              />
            </form>
          )}
        />

        <Dialog
          open={this.state.rangeModalOpen}
          onClose={this.handleRangeModalClose}
          aria-labelledby="range-dialog-title"
          aria-describedby="range-dialog-description"
          className={classes.rangeDialog}
        >
          {!this.state.rangeModalSubmitted && (
            <Formik
              validateOnChange={true}
              validationSchema={yup.object({
                email: yup.string().email().label("Email").required(),
              })}
              initialValues={{
                email: "",
              }}
              onSubmit={(values, actions) => {
                // duplicate the object
                let valuesToSendToBackend = JSON.parse(JSON.stringify(values));

                valuesToSendToBackend = {
                  ...valuesToSendToBackend,
                  ...this.values,
                };

                //Somehow add locations as values too
                return (
                  axios
                    .request({
                      method: "post",
                      url: runtimeEnv().REACT_APP_API_URL + "/leads/outofrange",
                      data: valuesToSendToBackend,
                    })
                    // eslint-disable-next-line no-unused-vars
                    .then((response) => {
                      actions.setSubmitting(false);
                      this.setState({ rangeModalSubmitted: true });
                    })
                    .catch((error) => {
                      actions.setSubmitting(false);
                      actions.setErrors(error.response.data.fields || {});
                      actions.setStatus({
                        message: error.response.data.message,
                      });

                      console.log(error); //eslint-disable-line no-console
                      console.log(error.response); //eslint-disable-line no-console
                    })
                );
              }}
              render={({
                values,
                errors,
                status,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
                // eslint-disable-next-line no-unused-vars
                setFieldValue,
                // eslint-disable-next-line no-unused-vars
                setFieldError,
                isSubmitting,
              }) => (
                <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                  <DialogTitle id="range-dialog-title">
                    We&#39;re Sorry
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="range-dialog-description">
                      We are not servicing this area yet but we are growing and
                      hope to soon.
                    </DialogContentText>
                    <DialogContentText id="range-dialog-description2">
                      Enter your email below to be notified when we do.
                    </DialogContentText>
                    {status && status.message && (
                      <FormErrorMessage message={status.message} />
                    )}
                    <TextField
                      name={"email"}
                      label="Email"
                      className={classes.textField}
                      disabled={isSubmitting}
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.email && errors.email}
                      error={touched.email && !!errors.email}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                    />
                  </DialogContent>
                  <DialogActions className={classes.dialogActions}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Notify me
                    </Button>
                  </DialogActions>
                </form>
              )}
            />
          )}
          {this.state.rangeModalSubmitted && (
            <>
              <DialogTitle id="range-dialog-title">Thanks</DialogTitle>
              <DialogContent>
                <CheckCircleIcon className={classes.icon} color="primary" />
              </DialogContent>
              <DialogContent>
                <DialogContentText id="range-dialog-description">
                  We&#39;ll be in touch
                </DialogContentText>
              </DialogContent>
            </>
          )}
        </Dialog>
      </>
    );
  }
}

OriginDestination.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  steps: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
};

export default withStyles(styles)(OriginDestination);
